// Canonical site URL. Used for auth redirect URLs, share links, OG, etc.
// Falls back to the current origin in local/preview environments.
export const SITE_URL =
  (typeof window !== "undefined" && window.location?.origin?.includes("guardiannest.net"))
    ? "https://guardiannest.net"
    : (typeof window !== "undefined" ? window.location.origin : "https://guardiannest.net");

export const CANONICAL_URL = "https://guardiannest.net";

/** Where Supabase should redirect the user after confirming their email. */
export function authRedirectUrl(path = "/auth") {
  // Prefer current origin in preview/dev (so confirmation works), production prod → guardiannest.net
  if (typeof window === "undefined") return `${CANONICAL_URL}${path}`;
  const origin = window.location.origin;
  return `${origin}${path}`;
}
